import { cn } from "@theprelude/core";

export const FirewallIcon: React.FC<React.ComponentPropsWithoutRef<"svg">> = ({
  className,
  ...props
}) => (
  <svg
    className={cn("size-4 flex-shrink-0", className)}
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3.78307 2.82598L12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598ZM5 4.60434V13.7889C5 15.1263 5.6684 16.3752 6.7812 17.1171L12 20.5963L17.2188 17.1171C18.3316 16.3752 19 15.1263 19 13.7889V4.60434L12 3.04879L5 4.60434Z" />
    <path d="M12 17C14.2091 17 16 15.1258 16 12.814C16 12.3309 15.8772 11.8669 15.7333 11.4351C14.8444 12.3543 14.1689 12.814 13.7067 12.814C15.8375 8.90698 14.6667 7.23256 11.4667 5C11.7333 7.79042 9.97548 9.05977 9.25962 9.76461C8.48419 10.5281 8 11.6118 8 12.814C8 15.1258 9.79086 17 12 17Z" />
  </svg>
);
